import type { Action } from '@reduxjs/toolkit'
import type { Observable, ObservableInput } from 'rxjs'
import { EMPTY, catchError, defer, of } from 'rxjs'
import { messageOf } from './messages.ts'

/**
 * One action's work, with any error it throws, even synchronously, turned into a failure action (or
 * logged) right there. Left to escape, the error would restart the whole epic and drop the work other
 * drafts had in flight with it.
 */
export const guarded =
  <T>(what: string, project: (value: T) => ObservableInput<Action>, failure?: (value: T, message: string) => Action) =>
  (value: T): Observable<Action> =>
    defer(() => project(value)).pipe(
      catchError((error: unknown) => {
        console.error(`Order wizard: ${what} failed`, error)
        return failure ? of(failure(value, messageOf(error))) : EMPTY
      })
    )
